import React, { useCallback, useMemo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated from 'react-native-reanimated';
import { format, parseISO } from 'date-fns';
import { rem, Spacer, Button, AppView, SettingsSection, SCROLL_INDICATOR_INSETS, withAnimatedNavigationHeader, } from 'design-system';
import Text from 'design-system/Text';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import DateOfMonthPicker from 'design-system/DateOfMonthPicker';
import { formatDoubleDigit } from 'utils';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { RecurringBuyInterval } from '../types';
import { useCommonInvestStyles } from './styles';
import { strings } from '../components/OnboardingTitle';
import { isWeb } from '../../../constants';
const SelectDateScreen = withAnimatedNavigationHeader(({ route, navigation: { navigateDeprecated }, scrollHandler }) => {
    const { params } = route;
    const [date, selectDate] = useState(1);
    const commonStyles = useCommonInvestStyles();
    const onSubmit = useCallback(() => {
        if (date && params) {
            navigateDeprecated('InvestHoliday', {
                ...params,
                buyConfig: {
                    date,
                    interval: params.interval,
                },
            });
        }
    }, [date, params]);
    const marginBottom = useMarginBottom('marginBottom');
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const onDateSelect = useCallback((day) => {
        selectDate(day);
    }, []);
    const title = useMemo(() => {
        if (params.interval === RecurringBuyInterval.MONTHLY) {
            return 'Monthly';
        }
        return 'Quarterly';
    }, [params]);
    return (<AppView style={commonStyles.containerNoPadding} withFrame={false}>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} keyboardShouldPersistTaps="handled" scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={paddingHorizontalStyle}>
          <ScreenInfoHeader preTitle={title} title={strings.SelectDate.title} subTitle={strings.SelectDate.subtitle}/>
          <SettingsSection noMarginTop>
            <DateOfMonthPicker selectedDay={date} onSelect={onDateSelect} style={styles.calendarContainer}/>
          </SettingsSection>
        </Animated.ScrollView>
        <View style={paddingHorizontalStyle}>
          <View style={styles.infoContainer}>
            {!!date && (<Text TextThin-16 Secondary centered>
                Your order will be placed on the{' '}
                <Text Text-16 Secondary>
                  {format(parseISO(`2025-01-${formatDoubleDigit(String(date))}`), 'do')} day{' '}
                  {params.interval === RecurringBuyInterval.QUARTERLY ? 'every 3 months' : 'each month'}
                </Text>
              </Text>)}
          </View>
          <Spacer h={8}/>
          <Button brand title="Continue" onPress={onSubmit} style={[styles.button, marginBottom]}/>
        </View>
      </AppView>);
}, ({ colors }) => ({
    hideTitleOnScroll: true,
    title: strings.SelectDate.shortTitle,
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styles = StyleSheet.create({
    calendarContainer: {
        padding: rem(16),
        paddingBottom: 0,
    },
    infoContainer: {
        alignItems: 'center',
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
    },
    button: {
        marginHorizontal: rem(16),
    },
});
export default SelectDateScreen;
